import { Controller } from "stimulus"

// Clicking a customer or vendor row in the aging summary filters the detail
// table to that group; clicking the selected row again clears the filter.
export default class extends Controller {
  static targets = ["row", "detail"]

  toggle(event) {
    const row = event.currentTarget
    const groupId = row.dataset.groupId
    const selecting = !row.classList.contains("table-active")

    this.rowTargets.forEach(r => r.classList.toggle("table-active", selecting && r === row))
    this.detailTargets.forEach(detail => {
      detail.hidden = selecting && detail.dataset.groupId !== groupId
    })
  }
}
